import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import NismBadge from "./components/NismBadge";
import OnlineOfflineBadge from "./components/OnlineOfflineBadge";
import StatsStrip from "./components/StatsStrip";
import ProblemSolution from "./components/ProblemSolution";
import Founder from "./components/Founder";
import Courses from "./components/Courses";
import Comparison from "./components/Comparison";
import WhyChoose from "./components/WhyChoose";
import PhotoGallery from "./components/PhotoGallery";
import GoogleReviews from "./components/GoogleReviews";
import SEOContent from "./components/SEOContent";
import FAQ from "./components/FAQ";
import Blog from "./components/Blog";
import Location from "./components/Location";
import EnquiryForm from "./components/EnquiryForm";
import FinalCTA from "./components/FinalCTA";
import Disclaimer from "./components/Disclaimer";
import Footer from "./components/Footer";
import StickyButtons from "./components/StickyButtons";
import { Toaster } from "./components/ui/sonner";
import BlogIndex from "./pages/BlogIndex";
import BlogPost from "./pages/BlogPost";

const Home = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main className="pt-20">
        <section id="home">
          <Hero />
        </section>
        <NismBadge />
        <OnlineOfflineBadge />
        <StatsStrip />
        <ProblemSolution />
        <Founder />
        <section id="courses">
          <Courses />
        </section>
        <Comparison />
        <section id="why-choose">
          <WhyChoose />
        </section>
        <PhotoGallery />
        <GoogleReviews />
        <SEOContent />
        <FAQ />
        <Blog />
        <section id="location">
          <Location />
        </section>
        <section id="enquiry">
          <EnquiryForm />
        </section>
        <FinalCTA />
        <Disclaimer />
      </main>
      <Footer />
      <StickyButtons />
      <Toaster />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/blog" element={<BlogIndex />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
